<template>
  <div class="" data-comp="CameraTestProxy" style="padding-bottom: 50px;">
    <component :is="testComponent"></component>
  </div>
</template>

<script>
export default {
  name: 'TestProxy',
  components: {
    'PoseLandmarker': () => {
      return import('@/components/test/camera/pose-landmarker/PoseLandmarkerTest');
    },
    'FaceDetector': () => {
      return import('@/components/test/camera/media-pipe/face-detector/FaceDetectorTest');
    },
  },
  data () {
    return {};
  },
  computed: {
    testComponent () {
      const path = location.pathname;
      console.log('@ path:', path)
      let component = '';
      try{
        if(path.startsWith('/test/camera/pose-landmarker')){
          component = 'PoseLandmarker';
        }else if(path.startsWith('/test/camera/media-pipe/face-detector')){
          component = 'FaceDetector';
        }
        return component;
      }finally{
        document.title += '-' + component;
      }
    }
  },
  created () {
  }
}
</script>
